// extracted by mini-css-extract-plugin
export default {"tickle":"Tickle-module__tickle__kbNNiys","copilotRun":"Tickle-module__copilotRun__nKMQ6Ps"};